var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-component":"dummy"}},[_c(_vm.getComponent,{tag:"component",attrs:{"cardsInSuits":_vm.getCardsInSuits}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }